import { render, staticRenderFns } from "./DetailPage4.vue?vue&type=template&id=0e28b3cc"
import script from "./DetailPage4.vue?vue&type=script&lang=js"
export * from "./DetailPage4.vue?vue&type=script&lang=js"
import style0 from "./DetailPage4.vue?vue&type=style&index=0&id=0e28b3cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports